import { graphql } from '../../graphql/generated';

export const ECARD_ACTIONS_QUERY = graphql(`
  query EcardActions($doctorId: ID!) {
    ecardConfigs(doctorId: $doctorId) {
      id
      cardReaderAddress
      cardReaderName
      taetigkeitsBereichName
      taetigkeitsBereichId
      ordinationName
      ordinationId
      cardPin
      vpnr
    }
  }
`);
